import _ from 'lodash/';
import {
  boolCheckboxSpec,
  group,
  repeatable,
  stringInputSpec,
  stringSelectSpec,
} from '../../../lib/editing-configs';
import UniversalText from '../../universal-text/universal-text';
import { TABLE_STYLES } from '../types';

export default (componentDocument) => {
  const defaultTableStyleOptions =
    _.get(componentDocument, 'props.tableStyle', '') === ''
      ? [
          boolCheckboxSpec('hideHeader', 'Hide Header?'),
          boolCheckboxSpec('striped', 'Striped Table?'),
        ]
      : [];

  return [
    boolCheckboxSpec('centeredInParent', 'Centered In Parent'),
    group('Table Settings', [
      stringSelectSpec('tableStyle', 'Table Style', [...TABLE_STYLES]),
      boolCheckboxSpec('transposed', 'Transpose Table?'),
      ...defaultTableStyleOptions,
    ]),
    group(
      'Data',
      [
        repeatable('data', 'Data', 'Data', (i) => [
          boolCheckboxSpec('highlight', 'Highlight?', {
            help: 'If checked, the row or columns, depending on table being transposed, will be highlighted',
          }),
          repeatable('attributes', 'Attributes', 'Attribute', (j) => [
            stringInputSpec('header', 'Header'),
            ...UniversalText.getEditingConfig(
              componentDocument,
              'Value',
              [
                'groupButton',
                'fontWeight',
                'fontFamily',
                'textColor',
                'textSize',
                'textType',
              ],
              `data.${i}.attributes.${j}.value`,
              { text: { textType: 'text' } }
            ),
          ]),
        ]),
      ],
      {
        help: 'Data attributes need to have equivalent headers.',
      }
    ),
  ];
};
